import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  label: ({ mode }) => ({
    color: mode === 'light' ? theme.colorPalette.green_75 : theme.onCard.beige_25,
    fontWeight: 600,
    fontSize: 10
  }),
  tooltip: {
    height: 14,
    width: 14
  },
  section: {
    display: 'flex',
    alignItems: 'center'
  },
  ratingRow: {
    height: 32,
    gap: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center'
  },
  marketTierIcon: {
    color: theme.colorPalette.green_75,
    opacity: 0.4,
    height: 32
  },
  iconActive: ({ mode }) => ({
    color: mode === 'light' ? theme.colorPalette.green_75 : theme.onCard.white,
    opacity: 1
  }),
  noMarketTierText: {
    color: theme.onCard.beige_25,
    fontSize: 10,
    fontStyle: 'normal',
    fontWeight: 400
  },
  noRatingSection: {
    display: 'flex',
    gap: theme.spacing(1)
  }
});

export default makeStyles(styles);
